module.exports = __webpack_public_path__ + "img/arrow-yellow.16c17df.png";